
import React from 'react';
import GlassCard from '@/components/ui/GlassCard';
import { Shield, Lock, FileCheck, Database } from 'lucide-react';
import { useLanguage } from '@/components/i18n/language-provider';

const SecuritySection: React.FC = () => {
  const { t } = useLanguage();
  
  const securityFeatures = [
    {
      icon: <Shield className="h-8 w-8 text-[#d62d82]" />,
      title: t('security.architecture'),
      description: t('security.architectureDesc')
    },
    {
      icon: <Lock className="h-8 w-8 text-[#d62d82]" />,
      title: t('security.encryption'),
      description: t('security.encryptionDesc')
    },
    {
      icon: <FileCheck className="h-8 w-8 text-[#d62d82]" />,
      title: t('security.compliance'),
      description: t('security.complianceDesc')
    },
    {
      icon: <Database className="h-8 w-8 text-[#d62d82]" />,
      title: t('security.dataProtection'),
      description: t('security.dataProtectionDesc')
    }
  ];

  return (
    <div className="py-16 px-6 md:px-8 rounded-2xl bg-gradient-to-br from-brand-purple/10 to-brand-pink/10 backdrop-blur-xs">
      <div className="text-center mb-12">
        <span className="inline-block rounded-full px-3 py-1 text-sm bg-primary/10 text-primary font-medium mb-4">
          {t('security.trustSecurity')}
        </span>
        <h2 className="text-3xl font-bold mb-4">{t('security.title')}</h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          {t('security.description')}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {securityFeatures.map((feature, index) => (
          <GlassCard key={index} className="flex flex-col items-start" hoverEffect>
            <div className="mb-4">
              {feature.icon}
            </div>
            <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
            <p className="text-muted-foreground">{feature.description}</p>
          </GlassCard>
        ))}
      </div>
    </div>
  );
};

export default SecuritySection;
